import React, { useEffect, useState } from "react";

// Paste ONE of these (or both — Spotify takes priority).
// YouTube format: https://www.youtube.com/embed/VIDEO_ID
const SPOTIFY_EMBED = "";
const YOUTUBE_EMBED = "https://www.youtube.com/embed/lY5V4hSLWY8";

export default function Finale({ goTo }) {
  const [hearts, setHearts] = useState([]);

  useEffect(() => {
    const spawn = () => {
      setHearts((h) => [
        ...h.slice(-30),
        {
          id: Math.random(),
          left: Math.random() * 100,
          duration: 6 + Math.random() * 6,
          size: 14 + Math.random() * 22,
          delay: Math.random() * 2,
          drift: (Math.random() - 0.5) * 80,
          opacity: 0.4 + Math.random() * 0.5,
        },
      ]);
    };
    const i = setInterval(spawn, 600);
    return () => clearInterval(i);
  }, []);

  const hasSpotify = SPOTIFY_EMBED.trim().length > 0;
  const hasYouTube = YOUTUBE_EMBED.trim().length > 0;

  return (
    <div className="scene finale-scene">
      <div className="hearts-layer" aria-hidden="true">
        {hearts.map((h) => (
          <span
            key={h.id}
            className="heart-piece"
            style={{
              left: `${h.left}%`,
              fontSize: h.size,
              opacity: h.opacity,
              animationDuration: `${h.duration}s`,
              animationDelay: `${h.delay}s`,
              "--drift": `${h.drift}px`,
            }}
          >
            🖤
          </span>
        ))}
      </div>

      <h1 className="title finale-title">you made it.</h1>

      <p className="subtitle finale-copy">a song for you. play it loud.</p>

      <div className="finale-player">
        {hasSpotify ? (
          <iframe
            title="song"
            src={SPOTIFY_EMBED}
            width="100%"
            height="152"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
          />
        ) : hasYouTube ? (
          <div className="yt-wrap">
            <iframe
              title="song"
              src={YOUTUBE_EMBED}
              frameBorder="0"
              allow="autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
            />
          </div>
        ) : (
          <div className="finale-placeholder">
            paste a SPOTIFY_EMBED or YOUTUBE_EMBED url at the top of Finale.jsx
          </div>
        )}
      </div>

      <p className="finale-signoff">— angel</p>

      <button className="btn btn-ghost" onClick={() => goTo("intro")}>
        <span className="btn-text">↺ start over</span>
      </button>
    </div>
  );
}
